import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { selectCurrentRsUser } from '@app/core/state/user/user.selectors';
import { Store } from '@ngrx/store';

export const OrderGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const currentUser = store.selectSignal(selectCurrentRsUser)()!;

  if (!currentUser) { return false; }

  const {
    vehicles, registration, distributionCenter, wallBox, complementaryOrder
  } = currentUser.access;

  const activeFlags = [vehicles, registration, distributionCenter, wallBox, complementaryOrder].filter(Boolean);

  if (activeFlags.length === 1) {
    if (complementaryOrder) {
      return router.parseUrl('/complementary-orders');
    }

    if (wallBox) {
      return router.parseUrl('/ev-products');
    }
  }

  return vehicles;
};
